import {IChannel, IDocument, IProduct, IScheme} from '../models';
import { getIncludedResource } from '../util';

export function fromJsonApi(data, included: any[]): IChannel {
  const {
    name,
    channel_type: channelType,
    key,
    whitelabel,
    metadata,
  } = data.attributes;

  const schemes = getIncludedResource(data, included, 'schemes', true).map((resource): IScheme => {
    const {
      id,
      cover_level: coverLevel,
      scheme_type: schemeType,
      status,
      logo,
      name,
      insurer,
      documents,
      metadata,
    } = resource.attributes;

    return {
      id,
      cover_level: coverLevel,
      scheme_type: schemeType,
      status,
      logo,
      name,
      insurer,
      documents,
      metadata,
    };
  });

  const products = getIncludedResource(data, included, 'products', true).map((resource): IProduct => {
    const {
      name,
      product_type: productType,
      product_code: productCode,
      status,
      summary,
      description,
      icon,
      metadata,
      documents,
    } = resource.attributes;

    return {
      id: resource.id,
      name,
      productType,
      productCode,
      status,
      summary,
      description,
      icon,
      metadata,
      documents,
    };
  });

  const productDocuments = getIncludedResource(data, included, 'product_documents', true).map((resource): IDocument => {
    const {
      name,
      file_path: filePath,
      short_name: shortName,
    } = resource.attributes;

    return {
      id: resource.id,
      name,
      filePath,
      shortName,
    };
  });

  const urls: any = metadata.urls ? metadata.urls : {};

  return {
    id: data.id,
    name,
    channelType,
    key,
    whitelabel,
    products,
    productDocuments,
    schemes,
    baseName: metadata.content.base_name,
    phone: metadata.content.phone,
    footer: metadata.content.footer,
    openingHours: metadata.content.opening_hours,
    offlineSchedule: metadata.offline_schedule,
    gtmId: metadata.gtm_id,
    channelLogo: metadata.channel_logo,
    additionalLogo: metadata.additional_logo,
    steps: metadata.steps,
    favicon: metadata.favicon,
    cseScript: metadata.cse_script,
    urls: {
      mainPage: urls.main_page,
      contactUs: urls.contact_us,
      aboutUs: urls.about_us,
      keyFeatures: urls.key_features,
      faq: urls.faq,
      privacyCookies: urls.privacy_cookies,
    },
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/channels.ts